import React, {useCallback, useState} from 'react';
import {DialogGeneric} from '../../../../core/dialog/DialogGeneric';
import CancelButton from '../../../../core/Buttons/CancelButton';
import SubmitButton from '../../../../core/Buttons/SubmitButton';
import {tid} from '../../../../../testUtils';
import {Error16} from '@carbon/icons-react';
import {ScenarioDTO, UserBaseDTO} from 'hemwb-api';
import {updateShareInstance} from '../../../../../store/scenario';
import {messageAdd, MessageTypes} from '../../../../../store/message';
import {useDispatch} from 'react-redux';

type ModelRequestAccessDialogProps = {
  scenario: ScenarioDTO;
  open: boolean;
  user: UserBaseDTO;
  onSuccess?: () => void;
  onCancel?: () => void;
};

const ScenarioShareRemoveDialog: React.FC<ModelRequestAccessDialogProps> = ({
  scenario,
  open,
  user,
  onSuccess,
  onCancel,
}) => {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = useCallback(() => {
    setSubmitting(true);
    updateShareInstance(dispatch, scenario.id, user.id, 'INACTIVE').then(() => {
      onSuccess?.();
      dispatch(messageAdd('Instance has been updated', MessageTypes.SUCCESS));
    });
    setSubmitting(false);
  }, [onSuccess, dispatch, scenario, user]);

  return (
    <DialogGeneric open={open} title="" PaperProps={tid('dialog-request-access') as object} childrenAsText={false}>
      <>
        <div>
          Do you want to stop sharing {scenario.name} instance with {user.firstName}, {user.lastName} ?
        </div>
        <div className="buttonsContainer">
          <br />
          <br />
          <CancelButton onClick={onCancel} {...tid('dialog-sharing-stop', 'Cancel')} />
          <SubmitButton
            endIcon={<Error16 />}
            onClick={handleSubmit}
            active={submitting}
            {...tid('dialog-sharing-stop', 'Stop Sharing')}
          >
            Stop Sharing
          </SubmitButton>
        </div>
      </>
    </DialogGeneric>
  );
};

export default ScenarioShareRemoveDialog;
